import wiser_by_feller from '../../../assets/card-images/wiser_by_feller.png';
import disposuite_sld from '../../../assets/card-images/disposuite_sld.png';
import disposuite_image from '../../../assets/card-images/disposuite.png';
import training from '../../../assets/card-images/training.svg';
import disposuite_icon from '../../../assets/card-images/disposuite.svg';
import wiser_setup from '../../../assets/card-images/wiser_setup.svg';
import myfeller_portal from '../../../assets/card-images/myfeller_portal.svg';
import youtube_image from '../../../assets/card-images/feller_youtube.png';

import google_play from '../../../assets/google-play.svg';
import app_store from '../../../assets/app-store.svg';

import { FELLER_ADMIN } from '../../../utils/constants';

const { REACT_APP_PORTAL_URL, REACT_APP_DISPOSUITE_URL, REACT_APP_TRAINING_URL } = process.env;

const sections = [
  {
    type: 'tutorials',
    title: 'welcome.sectionTutorialsTitle',
    buttonText: 'welcome.watch',
    cards: [
      {
        img: wiser_by_feller,
        title: 'helperCard.titleWiser',
        text: 'helperCard.textWiser',
        link: {
          de: 'https://www.youtube.com/playlist?list=PLSbybXVYGpSBdadUqKXhuhKzCKh4OaoG_',
          en: 'https://www.youtube.com/playlist?list=PLSbybXVYGpSBdadUqKXhuhKzCKh4OaoG_',
          fr: 'https://www.youtube.com/playlist?list=PLSbybXVYGpSAiTKx4nALkXnVhqED5z6oe',
          it: 'https://www.youtube.com/playlist?list=PLSbybXVYGpSAUCRfYWI9CKvtGfJyqOZNs',
        },
      },
      {
        img: disposuite_sld,
        title: 'helperCard.titleDispoSuiteSLD',
        text: 'helperCard.textDispoSuiteSLD',
        link: {
          de: 'https://youtu.be/oLZZkOv8CV0',
          en: 'https://youtu.be/oLZZkOv8CV0',
          fr: 'https://youtu.be/t6RH4JOHFzU',
          it: 'https://youtu.be/R5l7a_XtakI',
        },
      },
      {
        img: disposuite_image,
        title: 'helperCard.titleDisposuite',
        text: 'helperCard.textDisposuite',
        link: {
          de: 'https://youtu.be/gz6QM5ydkYo',
          en: 'https://youtu.be/gz6QM5ydkYo',
          fr: 'https://youtu.be/kww1zC6_s4Y',
          it: 'https://youtu.be/G8NMuzTe83o',
        },
      },
      {
        img: youtube_image,
        title: 'helperCard.titleYoutube',
        text: 'helperCard.textYoutube',
        link: {
          de: 'https://www.youtube.com/channel/UCcrBkHSuMiQEfUKRunfvUAA ',
          en: 'https://www.youtube.com/channel/UCcrBkHSuMiQEfUKRunfvUAA ',
          fr: 'https://www.youtube.com/channel/UCcrBkHSuMiQEfUKRunfvUAA ',
          it: 'https://www.youtube.com/channel/UCcrBkHSuMiQEfUKRunfvUAA ',
        },
      },
    ],
  },
  {
    type: 'applications',
    title: 'welcome.sectionApplicationsTitle',
    buttonText: 'welcome.open',
    cards: [
      {
        img: training,
        title: 'helperCard.titleTraining',
        text: 'helperCard.textTraining',
        information: {
          de: 'https://online-katalog.feller.ch/ausbildung/ausb_feller.php?a=FELLER&id=',
          en: 'https://online-katalog.feller.ch/ausbildung/ausb_feller.php?a=FELLER&id=',
          fr: 'https://online-katalog.feller.ch/ausbildung/ausb_feller.php?a=FELLER&id=&sc_lang=fr',
          it: 'https://online-katalog.feller.ch/ausbildung/ausb_feller.php?a=FELLER&id=&sc_lang=it',
        },
        link: {
          de: `${REACT_APP_TRAINING_URL}/de`,
          en: `${REACT_APP_TRAINING_URL}/de`,
          fr: `${REACT_APP_TRAINING_URL}/fr`,
          it: `${REACT_APP_TRAINING_URL}/it`,
        },
      },
      {
        img: disposuite_icon,
        title: 'helperCard.titleDisposuite',
        text: 'helperCard.textDisposuiteApp',
        information: {
          de: 'https://www.feller.ch/de/Support/Planungssoftware-DispoSuite',
          en: 'https://www.feller.ch/de/Support/Planungssoftware-DispoSuite',
          fr: 'https://www.feller.ch/fr/Support/Planungssoftware-DispoSuite',
          it: 'https://www.feller.ch/it/Support/Planungssoftware-DispoSuite',
        },
        link: REACT_APP_DISPOSUITE_URL,
      },
      {
        img: wiser_setup,
        title: 'helperCard.titleWiserESetup',
        text: 'helperCard.textWiserESetup',
        information: {
          de: 'https://wiser.feller.ch/de/professionals/workflow/app/',
          en: 'https://wiser.feller.ch/de/professionals/workflow/app/',
          fr: 'https://wiser.feller.ch/fr/professionals/workflow/app/',
          it: 'https://wiser.feller.ch/it/professionals/workflow/app/',
        },
        downloadButtons: [
          {
            text: 'Google play',
            img: google_play,
            link: 'https://play.google.com/store/apps/developer?id=Feller+AG',
          },
          {
            text: 'App store',
            img: app_store,
            link: 'https://apps.apple.com/ch/developer/feller-ag/id525095492',
          },
        ],
      },
      {
        img: myfeller_portal,
        title: 'helperCard.titleInternalPortal',
        text: 'helperCard.textInternalPortal',
        link: REACT_APP_PORTAL_URL,
        roles: [FELLER_ADMIN],
      },
    ],
  },
];

export default sections;
